
import Vue from "vue";

export default Vue.extend({
  name: "component-same-building-card-header",
  props: {
    pcSelectedCard: { type: Boolean, default: false },
    buildingName: { type: String, required: true },
  },
  methods: {
    showSameBuildingList() {
      this.$emit("show-same-building-list");
    },
  },
});
